import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Services from '../components/Services';
import Contact from '../components/Contact';

const ServicesPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow pt-20">
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;